<script setup lang="ts">
const props = defineProps<{
  noBody?: boolean;
  background?: string;
  backgroundAlt?: string;
}>();
</script>

<template>
  <div
    class="card"
    :class="{ 'with-bg': props.background }"
  >
    <Image
      v-if="props.background"
      :src="props.background"
      :alt="backgroundAlt || ''"
      class="bg-img"
      no-placeholder-icon
    />
    <header
      v-if="$slots.header"
      class="card-header"
    >
      <slot name="header"></slot>
    </header>
    <div
      v-if="!noBody"
      class="card-body"
    >
      <slot></slot>
    </div>
    <slot v-if="noBody"></slot>
    <footer
      v-if="$slots.footer"
      class="card-footer"
    >
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style scoped lang="postcss">
.card {
  @apply relative border border-light-500 bg-light-100 shadow-lg shadow-light-500;
}

.bg-img {
  @apply absolute overflow-hidden rounded-xl;
}
.card-body {
  @apply z-10 px-3 py-4 md:px-8 md:py-8;
}
.card-header {
  @apply border-b border-b-light-700 px-3 py-4 md:px-8 md:py-5;
}
.card-footer {
  @apply flex items-stretch border-t border-t-light-700;
  & > :first-child {
    @apply rounded-bl-xl;
    select {
      @apply rounded-bl-xl;
    }
  }
  & > :only-child {
    @apply flex-1;
  }
  & > :not(:last-child) {
    @apply border-r border-r-light-700;
  }
  & > :last-child {
    @apply rounded-br-xl;
  }
  :deep() {
    .form-control select {
      @apply flex-1 rounded-t-none rounded-br-none bg-transparent px-8 py-5 leading-4 transition-all;
      &:hover,
      &:focus-visible {
        @apply bg-black/5;
      }
    }
    .card-button {
      &:first-child {
        @apply rounded-bl-xl;
      }
      &:last-child {
        @apply rounded-br-xl;
      }
    }
  }
}

@media screen {
  html.dark {
    .card {
      @apply text-white;
    }
  }
}
</style>
